import http from './http';

export const getValuationDates = async (isin: string) => {
  return http.get('/esg-funds/valuation-dates', { isin });
};

export const getSnapshot = async (isin: string, valuationDate: string) => {
  return http.get('/esg-funds/snapshot', { isin, valuationDate });
};

export const applySnapshotToDocument = async (documentId: string, valuationDate: string) => {
  return http.post('/esg-funds/apply', { documentId, valuationDate });
};
